{
  "close": "Sule",
  "notifications": "Teated"
}
